import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';

import { FRAGMENT_CO_ASSET } from './schema';

const MUTATION = gql`
  mutation CreateCOAssetFromDraft($projectId: ID!, $draftAssetId: ID!, $segmentId: ID!) {
    createLandingPageAssetFromDraft(
      projectId: $projectId
      draftAssetId: $draftAssetId
      continuousOptimizationSegmentId: $segmentId
    ) {
      ...LandingPageAsset
    }
  }
  ${FRAGMENT_CO_ASSET}
`;

export function createCOAssetFromDraft({ projectId, draftAssetId, segmentId }) {
  return executeGqlMutation({
    mutation: MUTATION,
    variables: { projectId: String(projectId), draftAssetId, segmentId },
  }).then(({ data }) => getSingleProp(data));
}
